import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPermissions } from "../utils/utils";

const Bienvenido = () => {
  return <div className="text-dark"> 
    <h1>
      Diamond Central 
    </h1>
    <h4>
      <i>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Construyendo Juntos
      </i>
    </h4>
  </div>;
};

export default Bienvenido;
